
export const isProd = true;

export const API_URL = isProd 
  ? 'https://api.cugsgames.com:9443/api'  
  : 'http://localhost:5000';

export default API_URL;